//Début de action-add-supplier_invoice
$(function() {

  const $viewSupplier = $("#supplier_invoice_view_supplier_id");
  if ($viewSupplier.length && $.fn.select2) {
    $viewSupplier.select2({
      language: "fr",
      placeholder: "Sélectionner un fournisseur",
      ajax: {
        url: `${window.baseUrl}supplier_invoice/select2/supplier_invoice_supplier_id`,
        dataType: "json",
        data: function(params) {
          return {
            search: params.term,
            page: params.page || 1
          };
        },
        processResults: function(data) {
          return data;
        }
      }
    });
  }

  $(document).on("submit", "#form_supplier_invoice_view", function(event) {
    event.preventDefault();
    const form = $(this);

    App.blockUI({ message: "Enregistrement...<br>Veuillez patienter", boxed: true, zIndex: 20000 });
    $.ajax({
      url: `${window.baseUrl}supplier_invoice/edit/save`,
      type: "POST",
      data: {
        id: form.data("supplier-invoice-id"),
        form: form.serialize(),
        from: "view"
      },
      dataType: "json"
    }).done(function() {
      App.unblockUI();
      toastr.success("Facture de fournisseur enregistrée avec succès.");
      window.location.reload();
    }).fail(function(jqXHR, textStatus, thrownErr) {
      App.unblockUI();
      processXHRError(jqXHR, textStatus, thrownErr);
      console.error("Request to save supplier invoice details failed:", textStatus);
    });
  });

  $(".action-add-supplier_invoice").off("focus");
  $(".action-add-supplier_invoice").off("click");
  $(".action-add-supplier_invoice").on("click", function() {
    var from = $(this).closest(".page-top").length > 0 ? "page-top" : "list";

    var message_text = `<h1>${L("PROCESSING")}...<br>${L("PLEASE_WAIT")}</h1>`;
    App.blockUI({ message: message_text, boxed: true, zIndex: 20000 });
  
    $.ajax({
      url: `${window.baseUrl}supplier_invoice/add`,
      type: "POST",
      data: { },
      dataType: "html"
    }).done(function (msg) {
      App.unblockUI();
      var popup = bootbox.dialog({ 
        message: msg,
        title: "Ajout",
        className: "modal-supplier_invoice",
        size: "large",
        buttons: {
          save: {
            label: L("SAVE"),
            className: "purple",
            callback: function() {
              if($("#form_supplier_invoice").valid()){
                addSupplier_invoice($("#form_supplier_invoice").serialize(), from != "page-top", function(success){
                  processPopupServerResponse(popup, success);
                });
              }
              return false;
            }
          },
          cancel: {
            label: L("CANCEL"),
            className: "btn",
            callback: function() {
              
            }
          }
        }
      });
  
      popup.find(".modal-dialog").addClass("modal-xxlg")
  
      popup.on("shown.bs.modal", function(e) {
        refreshVue("#form_supplier_invoice");
      });
    }).fail(function(jqXHR, textStatus, thrownErr) {
      App.unblockUI();
      processXHRError(jqXHR, textStatus, thrownErr);
      console.log( "Request add supplier_invoice failed: " + textStatus );
    });
  
  });
  //FIN de action-add-supplier_invoice

})

window.addSupplier_invoice = (data, redirect, callback) => {
	if(callback == undefined) callback = function(success){ };
	var message_text = `<h1>${L("SAVING")}...<br>${L("PLEASE_WAIT")}</h1>`;
	App.blockUI({ message: message_text ,boxed: true, zIndex: 20000 });
	$.ajax({
		url: `${window.baseUrl}supplier_invoice/add/save`,
		type: "POST",
		data: { form : data },
		dataType: "html"
	}).done(function(msg) {
		App.unblockUI();
		callback(true);
    if(redirect) {
      window.location = `${window.baseUrl}supplier_invoice/view/${msg}`;
    } else {
      toastr.success("Facture de fournisseur ajouté avec succès!", "Succès", {
        onclick: function() {
          window.location = `${window.baseUrl}supplier_invoice/view/${msg}`;
        }
      })
    }
  }).fail(function(jqXHR, textStatus, thrownErr) {
		App.unblockUI();
		processXHRError(jqXHR, textStatus, thrownErr);
		callback(false);
		console.log( "Request addSupplier_invoice failed: " + textStatus );
	});
}